import { useEffect, useRef } from 'react';

export default function FollowActionDialog({ title, description, busy, onCancel, onConfirm }: {
  title: string; description: string; busy: boolean; onCancel: () => void; onConfirm: () => void;
}) {
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => { const node = dialog.current; node?.showModal(); return () => node?.close(); }, []);
  return <dialog ref={dialog} onCancel={event => { event.preventDefault(); if (!busy) onCancel(); }}
    aria-labelledby="follow-action-title" aria-describedby="follow-action-description"
    className="w-[calc(100%_-_32px)] max-w-md rounded-2xl p-6 backdrop:bg-black/40">
    <h2 id="follow-action-title" className="text-lg font-semibold text-gray-900">{title}</h2>
    <p id="follow-action-description" className="mt-3 whitespace-pre-line break-words text-sm leading-relaxed text-gray-600">{description}</p>
    <div className="mt-6 flex gap-3">
      <button autoFocus type="button" disabled={busy} onClick={onCancel} className="min-h-11 flex-1 rounded-xl border px-4 text-sm disabled:opacity-50">取消</button>
      <button type="button" disabled={busy} onClick={onConfirm} className="min-h-11 flex-1 rounded-xl bg-indigo-600 px-4 text-sm text-white disabled:opacity-50">{busy ? '正在处理…' : '确认操作'}</button>
    </div>
  </dialog>;
}
